/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React from "react";
import { useTranslation } from 'react-i18next';
import Popover from 'components/Popovers/RightPopover';
import history from "../../history";
import Loading from 'components/Loading/Loading';
export default function CardStats({
  statSubtitle = "Traffic",
  statTitle = "undefined",
  statTime = "last-m-avg",
  statIconName = "far fa-chart-bar",
  statIconColor = "bg-red-500",
  Last,
  Mavg = 9,
  time = "1976-04-19T12:59-0500"
}) {
  const funcUpDown = (Last, Mavg) => {
    if (Last >= Mavg) {
      return {
        arrow: "up",
        color: "text-green-500",
        value: (Last - Mavg).toFixed(1)
      }
    } else if (Last < Mavg) {
      return {
        arrow: "down",
        color: "text-red-500",
        value: (Mavg - Last).toFixed(1)
      }
    }
    return {
      arrow: "",
      color: "",
      value: ""
    }
  }
  const { t } = useTranslation();
  return (

    <>
      <div
        className="relative flex flex-col break-words bg-white rounded-lg shadow-lg cursor-pointer"
        onClick={() => {
          switch (statSubtitle) {
            case "ph-last-value":
              history.push("/admin/ph");
              break;
            case "ec-last-value":
              history.push("/admin/cond");
              break;
            case "tds-last-value":
              history.push("/admin/tds");
              break;
            case "orp-last-value":
              history.push("/admin/orp");
              break;
            case "do-last-value":
              history.push("/admin/oxygen");
              break;
            case "temp-last-value":
              history.push("/admin/temp");
              break;
            default:
              break;
          }
        }}

      >
        <div className="flex-auto p-4">
          {Last !== undefined ?
            <>
              <div className="flex flex-wrap">
                <div className="relative w-full pr-4 max-w-full flex-grow flex-1 " >
                  <h5 className="text-gray-500 font-bold text-xs">
                    {t(statSubtitle)}
                  </h5>
                  <span className="font-semibold text-xl text-gray-800">
                    {typeof statTitle === "string" ? statTitle : <>{statTitle.score}<span className="text-xs">{statTitle.dilim}</span></>}
                    <Popover time={time} />
                  </span>
                </div>
                <div className="relative w-auto pl-4 flex-initial">
                  <div
                    className={
                      "text-gray-700 p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full " +
                      statIconColor
                    }
                  >
                    <i className={statIconName}></i>
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-500 mt-4">
                <span className={funcUpDown(Last, Mavg).color + " mr-2"}>
                  <i
                    className={"fas fa-arrow-" + funcUpDown(Last, Mavg).arrow}
                  ></i>{" "}
                  {funcUpDown(Last, Mavg).value}
                </span>
                <span className="whitespace-no-wrap">{t(statTime)}</span>
              </p>
            </>
            :
            <Loading />
          }
        </div>
      </div>
    </>
  );
}